import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Paper, Stack, Typography } from "@mui/material";

import { AlertPanel } from "../../../../../../alert-panel/AlertPanel";
import { useClientFileContext } from "../../../../../context/ClientFileContext";
import { AssetInventorySection as AssetInventorySubTab } from "../../../../../routes/clientFileRoutes";
import { FormattedText } from "../../../formatted-text/FormattedText";

const TRANSLATION_BASE = "clients.client.debtSettlement.bankruptcyChecklist.bankruptcyCapability";

export function CapabilityEmptyState() {
  const { t } = useTranslation();
  const { basePaths } = useClientFileContext();

  return (
    <AlertPanel severity="warning" title={t(`${TRANSLATION_BASE}.noData.title`)}>
      <FormattedText text={t(`${TRANSLATION_BASE}.noData.text`)} />

      <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
        <Typography variant="overline" color="text.secondary">
          {t(`${TRANSLATION_BASE}.noData.requiredTitle`)}
        </Typography>
        <Stack component="ul" sx={{ m: 0, pl: 3 }}>
          <Typography component="li" variant="body2">
            {t(`${TRANSLATION_BASE}.noData.required.income`)}
          </Typography>
          <Typography component="li" variant="body2">
            {t(`${TRANSLATION_BASE}.noData.required.expenses`)}
          </Typography>
          <Typography component="li" variant="body2">
            {t(`${TRANSLATION_BASE}.noData.required.maintenance`)}
          </Typography>
        </Stack>
      </Paper>

      <Button
        variant="contained"
        component={RouterLink}
        to={`${basePaths.assetInventory}/${AssetInventorySubTab.Income}`}
        startIcon={<ArrowForwardIcon />}
        sx={{ mt: 2 }}
      >
        {t(`${TRANSLATION_BASE}.noData.linkLabel`)}
      </Button>
    </AlertPanel>
  );
}
